StageKo = App.loadClass "grower::viewmodels/nitrogen/Stage"

exports.Form = (handler, data, validator) ->
    self = this

    @addStage = () ->
        validator.stopValidating()
        self.stages.push new StageKo self, {}, validator
        validator.startValidating()

    @deleteStage = (stage) ->
        if self.stages().length > 1
            self.stages.remove stage
            self.deleted_stages.push stage

    @showDelete = () ->
        return self.stages().length > 1

    @getHandler = () ->
        return handler

    @getSource = (sourceid) ->
        return handler.taffyObjects.sources().filter(id: '==': sourceid).first()


    self.editing = ko.observable false

    stages = $.map data, (item) ->
        return new StageKo self, item, validator


    if stages.length is 0
        stages = [new StageKo self, {}, validator]


    stages = stages.reverse()
    @stages         = ko.observableArray stages ? []
    @deleted_stages = ko.observableArray []
    @year           = handler.loadLayoutPostOptions.year
    @fields_id      = handler.loadLayoutPostOptions.fields_id
    @layers_id      = handler.loadLayoutPostOptions.id ? null

    @total          = ko.computed () ->
        total = 0
        for v, k in self.stages()
            total += v.pounds()

        return total

    return this
